/**
 * 站点链接处理：把后台录入的地址规范成可访问的完整 URL。
 *
 * 后台「网站集合」里可能录入这些形式：
 *   - https://workbuddy.link/p/xxx   → 原样
 *   - www.example.com / example.com  → 补 https://
 *   - //example.com                  → 补 https:
 *   - #小程序://xxx                   → 小程序专用链接，网页无法打开
 *   - /analysis                      → 本站内路由
 */

/** 是否为本站内路由（以 / 开头） */
export function isInternalUrl(url) {
  return !!url && String(url).trim().startsWith("/");
}

/** 是否为小程序专用链接（#小程序://appid/xxx） */
export function isMiniProgramUrl(url) {
  return !!url && String(url).trim().startsWith("#");
}

/**
 * 规范化为完整 URL，无法转换时返回空字符串。
 * @param {string} url
 * @returns {string}
 */
export function normalizeSiteUrl(url) {
  const u = (url || "").trim();
  if (!u) return "";
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith("//")) return "https:" + u;
  if (isMiniProgramUrl(u)) return "";
  // 形如 www.xxx.com / xxx.com/path 的域名，补默认协议
  if (/^[\w-]+(\.[\w-]+)+(\/|$|\?)/.test(u)) return "https://" + u;
  return "";
}

/**
 * 新窗口打开外部站点；无法打开（如小程序链接）返回 false，由调用方提示。
 * @param {string} url
 * @returns {boolean}
 */
export function openExternalSite(url) {
  const href = normalizeSiteUrl(url);
  if (!href) return false;
  window.open(href, "_blank", "noopener");
  return true;
}

export default {
  isInternalUrl,
  isMiniProgramUrl,
  normalizeSiteUrl,
  openExternalSite,
};
